module.exports = __webpack_public_path__ + "static/img/EICAD.b7a6a9b2.png";